import React, { useState, useEffect } from 'react';
import { Button, Layout, Row } from 'antd';
// import { isMobile, MobileView } from 'react-device-detect';
import { Link, withRouter } from 'react-router-dom';
// import { UserOutlined } from '@ant-design/icons';
// import { useSelector, useDispatch } from 'react-redux';
// import { flow } from 'lodash-es';
// actions
import AppHeader from './AppHeader';
import AppSidebar from './AppSidebar';
import dayjs from 'dayjs';
import { LeftOutlined, RightOutlined } from '@ant-design/icons';
import { isMobile } from 'react-device-detect';
// import AppFooter from './AppFooter';

const { Content, Footer, Sider } = Layout;

const AppLayout = ({ children }) => {
  const [collapsed, setCollapsed] = useState(false);

  useEffect(() => {
    // Code inside componentDidMount can be placed here
    // if there's any equivalent functionality needed.
  }, []);

  const onCollapse = (collapsed) => {
    // console.log(collapsed);
    setCollapsed(collapsed);
  };

  return (
    <Layout style={{ minHeight: '100vh' }}>
      {
        <Sider
          breakpoint="lg"
          // collapsedWidth="0"
          collapsible
          collapsed={collapsed}
          onCollapse={onCollapse}
          style={{ background: '#f2f2f2' }}
          trigger={collapsed ? <LeftOutlined /> : <RightOutlined />}>
          <Row className="logo" justify="center">
            <Link to="/">
              {collapsed ? (
                <img
                  style={{ height: 30, width: 'auto' }}
                  src={require('../assets/img/logo-icon1.png')}
                  alt="Logo"
                />
              ) : (
                <img
                  style={{ width: '100%' }}
                  src={require('../assets/img/logo.png')}
                  alt="Logo"
                />
              )}
            </Link>
          </Row>
          <Row justify={'center'}>
            <AppSidebar collapsed={collapsed} />
          </Row>
        </Sider>
      }

      <Layout className="site-layout">
        {/* <Header className="site-layout-background" style={{ padding: 0 }} /> */}
        <AppHeader></AppHeader>
        <Content
          // style={
          //   isMobile
          //     ? { overflow: 'auto' }
          //     : { margin: '16px 16px', overflow: 'auto' }
          // }
          className="container-content">
          <div
            className="site-layout-background "
            style={{
              minHeight: 480,
              backgroundColor: '#f2f2f2',
            }}>
            {children}
          </div>
        </Content>
        <Footer style={{ textAlign: 'center', backgroundColor: '#f2f2f2' }}>
          Yobuma ©{dayjs().format('YYYY')} Created by Yobuma
        </Footer>
      </Layout>
    </Layout>
  );
};

export default withRouter(AppLayout);
